
































import {Component, Mixins} from 'vue-property-decorator'
import ModalBase from '../ModalBase.vue'
import {
  Modal,
  IModal
} from '@/entities'
import modalBaseMixin from "@/mixins/modal/modalBaseMixin";
import StepChain from "@/components/modal/StepChain.vue";
// steps
const ModalPlanPublicPerson = () => import('./ModalPlanPublicPerson.vue');
const ModalPlanPublicEmail = () => import('./ModalPlanPublicEmail.vue');

@Component({
  name: 'ModalPlanPublic',
  components: {
    ModalBase,
    StepChain,
    ModalPlanPublicPerson,
    ModalPlanPublicEmail
  }
})
export default class ModalPlanPublic extends Mixins(modalBaseMixin) {

  protected getModal(initSubject: any, initStep?: string, specific?: boolean): IModal {
    return new Modal({
      name: () => this.$options.filters?.capitalize(this.$t('plan-travel')),
      close: this.$storage.actions.closeModal,
      stepName: initStep,
      subject: initSubject,
      steps: [
        {
          name: 'person',
          controls: [
            {
              type: 'cancel',
              primary: false
            }, {
              type: 'next'
            }
          ]
        }, {
          name: 'email',
          controls: [
            {
              type: 'reset',
              label: 'ok',
              primary: false
            }, {
              type: 'ok',
              label: 'order-details'
            }
          ]
        }, {
          name: 'wallet',
          controls: [
            {
              type: 'ok'
            }
          ]
        }, {
          name: 'done',
          silent: true,
          controls: [
            {
              type: 'ok'
            }
          ]
        }
      ]
    });
  }

}
